interface PDFViewerProps {
  src: string;
  className?: string;
}

export function PDFViewer({ src, className = "" }: PDFViewerProps) {
  return (
    <iframe
      src={src}
      title="Resume PDF"
      className={`w-full ${className}`}
      style={{ minHeight: "80vh" }}
    />
  );
}
